export default {
  layoutModeCommit (state, data) {
    state.layoutMode = data
  }
}
